import { useCallback, useState } from "react";
import { toast } from "@jsq/ds/core";
import { updateMessageFeedback } from "../api/clients/messageClient";

export type UseMessageFeedbackParams = {
  onFeedbackUpdate?: (messageId: string, positiveFeedback: boolean | null) => void;
};

type UseMessageFeedbackReturn = {
  updateFeedback: (messageId: string, positiveFeedback: boolean | null) => Promise<void>;
  isUpdating: boolean;
};

export const useMessageFeedback = ({
  onFeedbackUpdate,
}: UseMessageFeedbackParams = {}): UseMessageFeedbackReturn => {
  const [isUpdating, setIsUpdating] = useState<boolean>(false);

  const updateFeedback = useCallback(
    async (messageId: string, positiveFeedback: boolean | null) => {
      setIsUpdating(true);
      try {
        await updateMessageFeedback(messageId, positiveFeedback);
        onFeedbackUpdate?.(messageId, positiveFeedback);
      } catch (error) {
        toast.error("Failed to update feedback. Please try again.");
      } finally {
        setIsUpdating(false);
      }
    },
    [onFeedbackUpdate],
  );

  return {
    updateFeedback,
    isUpdating,
  };
};
